import React from "react";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { StyledFooter, FooterText } from "./Footer.styled";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledFooter>
      <Row justify="center" align="middle">
        <Col xs={24} sm={12}>
          <FooterText>{t("footer.copyright")}</FooterText>
        </Col>
      </Row>
    </StyledFooter>
  );
};

export default Footer;
